import Button from '@pelckmans/elementis/components/button';
import Dialog from '@pelckmans/elementis/components/dialog';
import { useContext } from 'react';
import { SCORE_STATUS } from '../../../../../../constants/ScoreStatus';
import { MedialinkDialogHeaderTagsWithoutPillGroup } from '../../../../../../pages/material/components/MedialinkDialogHeaderTags';
import { ExerciseResult } from '../../@types/exercise-types';
import { useExerciseManagerContext } from '../../contexts/ExerciseManagerContext';
import { ExerciseTranslationsContext } from '../../contexts/ExerciseTranslationsContext';
import ExerciseHighLightedItem from '../exercise-highlighted-item';

export type LaunchModalCompletedSessionProps = {
  onReview: (sessionId: string) => void;
  onRestart?: () => void;
  result: ExerciseResult;
};

function LaunchModalCompletedSession({ onReview, onRestart, result }: LaunchModalCompletedSessionProps) {
  const translations = useContext(ExerciseTranslationsContext);

  const { medialink, module, onClose } = useExerciseManagerContext();

  const { session } = result;

  return (
    <Dialog
      id="launch-modal-completed-session"
      modal
      onClose={onClose}
      aria-label={translations.launchModalCompletedSession.a11yLabel}
    >
      <Dialog.Header
        title={translations.launchModalCompletedSession.title}
        onClose={onClose}
        aria-label={translations.closeDialog}
      />

      <Dialog.Body>
        <div className="modal-content-text">
          <p>
            {onRestart
              ? translations.launchModalCompletedSession.message.restartable
              : translations.launchModalCompletedSession.message.nonRestartable}
          </p>
        </div>
        <ExerciseHighLightedItem
          status={SCORE_STATUS.FINISHED}
          medialink={medialink}
          label={translations.launchModalCompletedSession.highlightedItem.label}
          scoreTitle={translations.launchModalCompletedSession.highlightedItem.score}
          percentageTitle={translations.launchModalCompletedSession.highlightedItem.percentage}
          resultTitle={translations.launchModalCompletedSession.highlightedItem.resultTitle}
          score={result.score}
          tags={{
            'aria-label': undefined,
            role: undefined,
            children: <MedialinkDialogHeaderTagsWithoutPillGroup module={module} material={medialink} />,
          }}
          phases={result.phases}
          isLastPhase={result.isLastPhase}
        />
      </Dialog.Body>
      <Dialog.Footer
        buttonGroupPropsLeft={
          session
            ? {
                'aria-label': undefined,
                role: undefined,
                children: (
                  <Button prominence="neutral" onClick={() => onReview(session)}>
                    {translations.launchModalCompletedSession.buttons.review}
                  </Button>
                ),
              }
            : undefined
        }
        buttonGroupPropsRight={{
          'aria-label': undefined,
          role: undefined,
          children: (
            <>
              <Button onClick={onClose} prominence="neutral" key="cancel">
                {translations.launchModalCompletedSession.buttons.cancel}
              </Button>
              {onRestart && (
                <Button onClick={onRestart} prominence="success" key="success">
                  {translations.launchModalCompletedSession.buttons.restart}
                </Button>
              )}
            </>
          ),
        }}
      />
    </Dialog>
  );
}

export default LaunchModalCompletedSession;
